import { OneContextStore } from '../../../one-context';
import type { Dispatch, UnknownAction } from 'redux';
import type { AuthState } from '@b2x/authentication';
import { isBrowser } from '../../../utils';

let loginCias: typeof import('@b2x/authentication').loginCias;
let loginViaPopup: typeof import('@b2x/authentication').loginViaPopup;
let logoutCias: typeof import('@b2x/authentication').logoutCias;
let registerCias: typeof import('@b2x/authentication').registerCias;
let subscribeIam: typeof import('@b2x/authentication').subscribeIam;

if (isBrowser()) {
  (async () => {
    const auth = await import('@b2x/authentication');
    loginCias = auth.loginCias;
    loginViaPopup = auth.loginViaPopup;
    logoutCias = auth.logoutCias;
    registerCias = auth.registerCias;
    subscribeIam = auth.subscribeIam;
  })();
}

// state
export const AUTHENTICATION_CONNECTION_NAME = 'AUTHENTICATION_CONNECTION';

const setAuthenticationStateActionName = 'SET_AUTHENTICATION_STATE';

type AuthStateOneContext = AuthState & {
  isPending: boolean;
};

const initialState: AuthStateOneContext = {
  jwe: null,
  email: null,
  isLoggedIn: false,
  isMfaEnabled: false,
  isPending: true,
};

// dispatchers
type AuthenticationDispatchers = {
  login: typeof loginCias;
  loginViaPopup: typeof loginViaPopup;
  logout: typeof logoutCias;
  register: typeof registerCias;
};

// connection
export class AuthenticationConnection extends OneContextStore<AuthenticationDispatchers, AuthStateOneContext> {
  readonly allowedTenants = ['iam'];

  get initialState() {
    return initialState;
  }

  constructor() {
    super(AUTHENTICATION_CONNECTION_NAME);
  }

  async onBeforeRegister(dispatch: Dispatch<UnknownAction>): Promise<void> {
    return new Promise((resolve) => {
      subscribeIam((state) => {
        dispatch(this.getAction(setAuthenticationStateActionName, { ...state }));
        resolve();
      });
    });
  }

  getReducer() {
    return (state: AuthStateOneContext, action: any) => {
      return {
        ...state,
        ...action.payload,
        isPending: false,
      };
    };
  }

  public getPublicDispatchers(): AuthenticationDispatchers {
    return {
      login: loginCias,
      loginViaPopup,
      logout: logoutCias,
      register: registerCias,
    };
  }
}
